import React from 'react'
import classNames from 'classnames'

import {
  getAccountItems,
  getAccountDetails,
} from '@apiEnabler/ob-common/lib/account-utils'

import AccountId from '@apiEnabler/ob-common/lib/view/AccountId'

import style from './AccessAccountCard.module.css'

export default function AccessAccountCard({ account, index, isStaffMember }) {
  const accountItems = isStaffMember
    ? [
        [
          account.get('accountId'),
          account.get('type'),
          getAccountDetails(account.get('accountIdentification'), ' | '),
        ]
          .filter(Boolean)
          .join(' | '),
      ]
    : getAccountItems(account.accountIdentification)
  return (
    <div className={`${style.card} js-access-account-card-${index}`}>
      <div
        className={classNames(
          style.name,
          { [style.unavailable]: account.nameUnavailable },
          'js-account-card-name'
        )}
      >
        {account.name}
      </div>

      {(!account.accountIdentification.isEmpty() || isStaffMember) && (
        <AccountId
          items={accountItems}
          className={`${style.accountId} js-account-card-details`}
        />
      )}
    </div>
  )
}
